import CategoriesFull from './components/CategoriesFull';
import { Option } from 'owa-options-core';
import * as React from 'react';

let CategoriesOption: Option = {
    key: 'mailCategories',
    titleStringKey: 'optionTitle_categories',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_categories',
    fullOptionFormSettings: {
        render: () => <CategoriesFull />,
        isDirty: () => false,
        onSave: () => {
            return Promise.resolve();
        },
        onDiscard: () => {
            return;
        },
        hideSaveDiscard: () => {
            return true;
        },
    },
};

export default CategoriesOption;
